import Layout from '@/vab/layouts'
const appRoutes = [{
    path: '/display',
    name: 'Display',
    component: Layout,
    redirect: '/carousel',
    meta: {
        title: '展示',
        icon: 'apps-2-line',
    },
    hidden: true,
    children: [
        {
            path: 'carousel',
            name: 'Carousel',
            component: () => import('@/views/widget/carousel'),
            meta: {
                title: '轮播图',
                icon: 'image-2-fill',
                noCLosable: true,
            },
        },
        {
            path: 'banner',
            name: 'Banner',
            component: () => import('@/views/widget/banner'),
            meta: {
                title: '横幅',
                icon: 'image-line',
                noCLosable: true,
            },
        },
        {
            path: 'article',
            name: 'Article',
            component: () => import('@/views/widget/article'),
            meta: {
                title: '文章',
                icon: 'file-word-line',
                noCLosable: true,
            },
        },
        {
            path: 'wechatQrCode',
            name: 'WechatQrCode',
            component: () => import('@/views/widget/wechatQrCode'),
            meta: {
                title: '微信小程序码',
                icon: 'qr-code-line',
                noCLosable: true,
            },
        },
    ],
},]

export default appRoutes